module.exports = __webpack_public_path__ + "img/bottom_bg.df90d7b5.png";